import MaxWidthContainer from 'components/MaxWidthContainer';
import useSWR from 'swr';
import { swrFetcher } from 'utils/api';

const HomeGroupBuy = () => {
  const { data: groupBuyings } = useSWR('/api/v3/groupBuyings', swrFetcher);
  if (!groupBuyings) return null;
  const featured = groupBuyings[0];
  if (!featured) return null;

  return (
    <div className="my-6 lg:my-12">
      <MaxWidthContainer className="px-4 lg:px-0">
        <a
          href="/groupbuy"
          className="relative flex w-full items-center gap-4 rounded-2xl border-2 border-[#F5F5F5] bg-white p-4 shadow-md lg:gap-6 lg:px-6 lg:py-4"
        >
          {/* 限時 Badge */}
          <span className="absolute -left-2 -top-2 z-10 rounded-md border border-sorra-pink bg-white px-2 py-1 text-xs font-bold text-sorra-pink lg:text-lg">
            限時
          </span>
          <div className="flex-shrink-0">
            <div className="h-[64px] w-[64px] overflow-hidden rounded-lg lg:h-[112px] lg:w-[112px]">
              <img
                src={featured.images?.[0]?.url}
                alt={featured.name}
                className="h-full w-full object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <p className="truncate text-xs font-medium text-gray-600 lg:text-base">
              {featured.name}
            </p>
            <p className="text-base font-semibold text-[#111928] lg:text-2xl">
              團購活動進行中！🔥
            </p>
            <div className="flex items-center gap-2">
              <span className="text-base font-semibold text-sorra-pink lg:text-2xl">
                會員專屬價 ${featured.price}
              </span>
              {featured.original_price > 0 && (
                <span
                  className="inline-block text-xs font-medium text-gray-400 lg:text-xl"
                  style={{
                    backgroundImage:
                      'linear-gradient(to bottom right, transparent calc(50% - 0.5px), #9ca3af calc(50% - 0.5px), #9ca3af calc(50% + 0.5px), transparent calc(50% + 0.5px))',
                  }}
                >
                  ${featured.original_price}
                </span>
              )}
            </div>
          </div>

          {/* CTA Button */}
          <div className="hidden flex-shrink-0 lg:block">
            <span className="flex items-center gap-1.5 rounded-lg bg-sorra-pink px-5 py-2.5 text-base font-medium text-white">
              立即查看
              <img
                src="/svgs/chevron-right-white.svg"
                alt=""
                className="h-4 w-4"
              />
            </span>
          </div>

          <div className="block flex-shrink-0 lg:hidden">
            <img
              src="/svgs/chevron-right-pink.svg"
              alt=""
              className="h-5 w-5"
            />
          </div>
        </a>
      </MaxWidthContainer>
    </div>
  );
};

export default HomeGroupBuy;
